/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

export const SUPPORTED_LANGUAGES = {
  'en-gb': 'English',
  'ms-my': 'Bahasa Malaysia',
  'id-id': 'Bahasa Indonesia',
  'th-th': 'ภาษาไทย',
  'vi-vn': 'Tiếng Việt',
  'zh-tw': '繁體中文',
  'zh-hk': '繁體中文 (香港)',
  'zh-cn': '简体中文',
  'ja-jp': '日本語',
  'ko-kr': '한국어',
  'tr-tr': 'Türkçe',
  'km-kh': 'ភាសាខ្មែរ',
  'ru-ru': 'Русский',
  'uz-uz': 'Uzbek',
};

export type SupportedLocales = keyof typeof SUPPORTED_LANGUAGES;

export const SUPPORTED_LOCALES = Object.keys(
  SUPPORTED_LANGUAGES,
) as SupportedLocales[];

// Default language
export const DEFAULT_LANGUAGE: SupportedLocales = 'en-gb';
